export default __webpack_public_path__ + "static/flag-de-491e07e8d6c2fe1d738a0a538b1c3534.svg";